import React, { useState, useContext } from 'react'
import { Tooltip, message } from 'antd'
import CustomModal from "../Modals/CustomModal";
import { authDeAuthUsers } from '../../webServices/Apis';
import Loader from '../Loader/Loader';
import { subContractorContext } from '../SubContractor/SubContractor';


function AuthAccess() {
  const subContractors = useContext(subContractorContext); // access subcontractors here
  const [isModalOpen, setIsModalOpen] = useState(false)
  // const [authOpen, setAuthOpen] = useState(false)
  const [loading, setLoading] = useState(false)
  const [showAuth , setShowAuth] = useState(false)

 

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const hanldeCloseModal = () => {
    setIsModalOpen(false)
  }

  const handleAuthOpen = () => {
    setShowAuth(true)
  }



  const deAuthUsers = async (status) => {
    setLoading(true)
    try {
      const response = await authDeAuthUsers(status)
      if (response?.data?.success) {
        message.success(response?.data?.message)
        hanldeCloseModal();
        setShowAuth(false)
      }
    } catch (error) {
      console.log("Error while auth de-auth users", error)
      message.error(error?.response?.data?.message || "Server not responding")
    }
    finally {
      setLoading(false)
    }
  }


  return (
    <div className="bg-gray-200 text-black p-10 h-4/7 w-4/6 rounded-lg shadow-2xl shadow-blue-300 mt-10 ml-48">
      <div className="w-full text-center mb-8">
        {loading && (
          <Loader />
        )}
        <h1 className="text-red-500 font-bold mb-2 mt-5">Pay cycle: The contractor system is disabled for unauthorized sub contractors</h1>
        <h2 className="text-3xl font-extrabold mb-2 bg-gray-400 ">Authorize/De-Authorize Access</h2>
        <h1 className="font-bold mb-2 mt-5">NOTE: De-Authorizing users overiddes this pay cycle's time checks!
          You will have to return to this page to Authorize users again.</h1>
      </div>


      <div className="flex flex-row justify-center gap-2 items-center mt-32">
        <Tooltip title="Click to De-Authorizing all users">
          <button
            onClick={() => handleOpenModal()}
            className="border border-red-500 bg-red-400 hover:bg-red-500 text-white font-bold py-2 px-12 rounded transition mr-4 shadow-md shadow-red-500"
          >
            De-Authorize All
          </button>
        </Tooltip>
        <Tooltip title="Authorize all users again !">
          <button
            onClick={() => handleAuthOpen()}
            className="border border-green-500 bg-green-400 hover:bg-green-500 text-white font-bold py-2 px-12 rounded transition mr-4 shadow-md shadow-green-500"
          >
            Authorize All
          </button>
        </Tooltip>
      </div>



      <CustomModal
        isOpen={isModalOpen}
        title="Confirm De-Authorize"
        message="Are you sure you want to De-Authorize all users ?"
        onConfirm={() => deAuthUsers(false)}
        onClose={() => hanldeCloseModal()}
      />

      {/* <CustomModal
        isOpen={authOpen}
        title="Confirm Authorize"
        message="Are you sure you want to Authorize all users ?"
        onConfirm={() => deAuthUsers(true)}
        onClose={() => handleAuthClose()}
      /> */}

{showAuth && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-full max-w-md">
            <h3 className="text-3xl font-bold mb-4 text-start text-black">Confirm Authorize</h3>
            <p className="mb-4 text-start text-black">Are you sure you want to authorize all users ? </p>
            <div className="flex justify-end gap-4">
              <button onClick={() => { setShowAuth(false) }} className="bg-gray-300 text-black py-3 px-8 rounded-md hover:bg-gray-400 transition duration-200">
                Cancel
              </button>
              <button onClick={() => deAuthUsers(true)} className="bg-green-600 text-white py-3 px-8 rounded-md mr-2 hover:bg-green-700 transition duration-200">
                Authorize
              </button>
            </div>
          </div>
        </div>
      )
      }

    </div>
  )
}

export default AuthAccess